import React, { FC } from "react";
import CommonLayout from "./CommonLayout";
import UserList from "./UserList";

export interface UserPageProps {
	className?: string;
}

const UserPage: FC<UserPageProps> = ({ className = "" }) => {
	return (
		<div className={`nc-SettingsPage ${className}`} data-nc-id="SettingsPage">
			{/* <Helmet>
				<title>Paramètres || IRIS GALERIE MAROC</title>
			</Helmet> */}
			<CommonLayout onSelectTab={(tab: String) => {}}>
				<div className="space-y-10 sm:space-y-12">
					{/* HEADING */}
					<UserList />
				</div>
			</CommonLayout>
		</div>
	);
};

export default UserPage;
